import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export function timephaseReducer(state = initialState.timePhases, action) {
	switch (action.type) {
		case types.GET_ALL_TIMEPHASES: {
			return action.response ?? state;
		}
		default:
			return state;
	}
}
